import { Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Title = styled(Typography)`
  display: flex;
  align-items: center;
`;

export const ChatsBlockWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
